import { SxProps, Theme } from '@mui/material';
import colors from '../../common/colors';

type FilterDrawerContainerStyles = {
  outerBar: SxProps<Theme>;
  searchFieldWrapper: SxProps<Theme>;
  clearButton: SxProps<Theme>;
  iconButtonWrapper: SxProps<Theme>;
  iconButton: SxProps<Theme>;
  badge: SxProps<Theme>;
  childBoxCollapsed: SxProps<Theme>;
  childBoxInline: SxProps<Theme>;
};

type FilterDrawerPanelStyles = {
  drawerPaper: SxProps<Theme>;
  drawerInner: SxProps<Theme>;
  header: SxProps<Theme>;
  title: SxProps<Theme>;
  body: SxProps<Theme>;
  footer: SxProps<Theme>;
};

export const containerStyles: FilterDrawerContainerStyles = {
  outerBar: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: { xs: '12px', md: '16px' },
    width: '100%',
  },
  searchFieldWrapper: {
    flex: '1 1 auto',
    minWidth: 0,
    maxWidth: '300px',
  },
  clearButton: {
    alignSelf: 'stretch',
  },
  iconButtonWrapper: {
    position: 'relative',
    flexShrink: 0,
  },
  iconButton: {
    backgroundColor: colors.neutral_200,
    width: 48,
    height: 48,
    borderRadius: 1,
    '&:hover, &:focus, &:active': {
      backgroundColor: colors.neutral_200,
    },
  },
  badge: {
    position: 'absolute',
    top: -4,
    right: -4,
    width: 18,
    height: 18,
    bgcolor: colors.grey_200,
    color: colors.white,
    fontSize: 11,
    fontWeight: 600,
    lineHeight: '18px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  childBoxCollapsed: {
    width: '100%',
    flex: '0 0 auto',
    minWidth: 'auto',
    maxWidth: '100%',
  },
  childBoxInline: {
    width: 'auto',
    flex: '1 1 auto',
    minWidth: '240px',
    maxWidth: '320px',
  },
};

export const panelStyles: FilterDrawerPanelStyles = {
  drawerPaper: {
    '& .MuiDrawer-paper': {
      width: { xs: '100vw', sm: '500px' },
      // Use dynamic viewport height so mobile browser bars can't push the pinned
      // footer (and its Save button) below the fold. Falls back to 100vh.
      height: '100vh',
      '@supports (height: 100dvh)': {
        height: '100dvh',
      },
      boxSizing: 'border-box',
    },
  },
  drawerInner: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    overflow: 'hidden',
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    px: 2,
    py: 2,
    borderBottom: `1px solid ${colors.neutral_300}`,
    boxSizing: 'border-box',
  },
  title: {
    color: colors.grey_200,
  },
  body: {
    flex: 1,
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
    p: 2,
  },
  footer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 2,
    px: 2,
    py: 2,
    // Extend the bottom padding past the device safe area (home indicator /
    // gesture bar) so the action buttons stay fully tappable on notched phones.
    pb: 'calc(16px + env(safe-area-inset-bottom))',
    borderTop: `1px solid ${colors.neutral_300}`,
    boxSizing: 'border-box',
  },
};
